const SET_NOTIFICATION = 'SET_NOTIFICATION'
const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION'
const SET_PAUSED = 'SET_PAUSED'
const SET_REMAINING = 'SET_REMAINING'

const DEFAULT_DURATION_MS = 4000

export const state = {
  current: null
}

export const mutations = {
  /**
   * Replace the visible notification atomically. Any previously
   * visible notification is discarded; we do not stack -- only the
   * most recent message is ever on screen.
   */
  [SET_NOTIFICATION] (state, payload) {
    state.current = payload
  },
  [CLEAR_NOTIFICATION] (state) {
    state.current = null
  },
  [SET_PAUSED] (state, paused) {
    if (state.current) {
      state.current = Object.assign({}, state.current, { isPaused: paused })
    }
  },
  [SET_REMAINING] (state, remainingMs) {
    if (state.current) {
      state.current = Object.assign({}, state.current, { remainingMs: remainingMs })
    }
  }
}

export const actions = {
  /**
   * Push a new transient notification. The component handles the
   * tick loop; this just seeds the state with the initial countdown.
   *
   * ``payload`` shape:
   *   message: string (required)
   *   kind: 'success' | 'error' | 'info' (default 'success')
   *   durationMs: number (default 4000)
   *   dismissible: boolean (default true)
   *   dismissLabel: string (a11y label for the close button)
   */
  show ({ commit }, payload) {
    if (!payload || !payload.message) {
      return
    }
    const durationMs = typeof payload.durationMs === 'number' && payload.durationMs > 0
      ? payload.durationMs
      : DEFAULT_DURATION_MS
    commit(SET_NOTIFICATION, {
      message: payload.message,
      kind: payload.kind || 'success',
      dismissible: payload.dismissible !== false,
      dismissLabel: payload.dismissLabel || 'Fechar notificação',
      durationMs: durationMs,
      remainingMs: durationMs,
      isPaused: false
    })
  },

  dismiss ({ commit }) {
    commit(CLEAR_NOTIFICATION)
  },

  pause ({ commit }) {
    commit(SET_PAUSED, true)
  },

  resume ({ commit }) {
    commit(SET_PAUSED, false)
  },

  /**
   * Advance ``remainingMs`` by ``elapsedMs`` unless the notification
   * is paused. When the timer crosses zero we clear the notification
   * so the component's transition can run a fade-out.
   */
  tick ({ commit, state }, elapsedMs) {
    if (!state.current || state.current.isPaused) {
      return
    }
    const next = Math.max(0, (state.current.remainingMs || 0) - elapsedMs)
    if (next <= 0) {
      commit(CLEAR_NOTIFICATION)
    } else {
      commit(SET_REMAINING, next)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
